import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

function Contact() {
    const form = useRef();
    const [sending, setSending] = useState(false);
    const sendEmail = (e) => {
        e.preventDefault();
        setSending(true);
        emailjs.sendForm('service_z2imi73', 'template_v8jp152', form.current, '0nUB6DNua_3NQ14sj')
            .then((result) => {
                console.log(result.text);
                toast.success(`Status : ${result.text}, Successfully Sent an Email`);
                setSending(false);

            }, (error) => {
                console.log(error.text);
                toast.error(`Status : ${error.text}, Something went Wrong`);
                setSending(false);
            });
    };
    return (
        <div className='mt-[20px] text-white max-w-[620px] w-[95%] mx-auto'
            data-aos="fade-up"
            data-aos-duration="1000"
        >
            <div className="card w-full shadow-2xl contact">
                <form ref={form} onSubmit={sendEmail} className="card-body">
                    <div className="form-control" data-aos="flip-up" data-aos-duration="1300">
                        <label className="label" htmlFor='email'>
                            <span className="label-text">Email</span>
                        </label>
                        <input type="text" name="user_email" required placeholder="" id='email' className="input input-bordered" />
                    </div>
                    <div className="form-control" data-aos="flip-up" data-aos-duration="1300">
                        <label className="label" htmlFor='userName'>
                            <span className="label-text">Your Name</span>
                        </label>
                        <input type="text" name="user_name" placeholder="" id='userName' className="input input-bordered" />
                    </div>
                    <div className="form-control" data-aos="flip-up" data-aos-duration="1600">
                        <label className="label" htmlFor='subject'>
                            <span className="label-text">Subject</span>
                        </label>
                        <input type="text" name="user_subject" placeholder="" id='subject' className="input input-bordered" />
                    </div>
                    <div className="form-control" data-aos="flip-up" data-aos-duration="1900">
                        <label className="label" htmlFor='message'>
                            <span className="label-text">Your Message</span>
                        </label>
                        <textarea required name='message' id="message" cols="30" rows="30" className='input h-[120px] input-bordered' placeholder=''></textarea>
                    </div>
                    <div className="form-control mt-6" data-aos="flip" data-aos-duration="2200">
                        <button className={`btn btn-primary hover:btn-secondary ${sending && 'pointer-events-none loading'}`}  type='submit'>Send Message</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Contact